import React, { useEffect } from 'react';

const ThesisFilter = ({ projects, setFiltered, active, setActive }) => {

  useEffect(() => {
    if (active === "all") {
      setFiltered(projects);
    }
    else {
      const filtered = projects.filter((project) => project.category === active);
      setFiltered(filtered);
    }
  }, [active, projects, setFiltered]);

  return (
    <div className="flex justify-center items-center py-12 flex-wrap gap-3">
      <button
        className={
          active === "all"
            ? "rounded mx-2 bg-indigo-900 py-2 px-4 text-white w-[100px] h-[40px]"
            : "rounded mx-2 bg-indigo-700 hover:bg-indigo-800 w-[100px] h-[40px]  py-2 px-4 text-white"
        }
        onClick={() => setActive("all")}
      >
        All
      </button>
      <button
        className={
          active === "data-science"
            ? "rounded mx-2 bg-indigo-900 py-2 px-4 w-[100px] h-[40px] text-white"
            : "rounded mx-2 bg-indigo-700 hover:bg-indigo-800 w-[140px] h-[40px]  py-2 px-4 text-white  sm:mt-0"
        }
        onClick={() => setActive("data-science")}
      >
        Data Science
      </button>
      <button
        className={
          active === "machine-learning"
            ? "rounded mx-2 bg-indigo-900 py-2 px-4 text-white"
            : "rounded mx-2 bg-indigo-700 hover:bg-indigo-800  py-2 px-4 text-white"
        }
        onClick={() => setActive("machine-learning")}
      >
         Machine Learning
      </button>
      <button
        className={
          active === "artificial-intelligence"
            ? "rounded mx-2 bg-indigo-900 py-2 px-4 text-white"
            : "rounded mx-2 bg-indigo-700 hover:bg-indigo-800  py-2 px-4 text-white"
        }
        onClick={() => setActive("artificial-intelligence")}
      >
        Artificial Intelligence 
      </button>
      <button
        className={
          active === "software-engineering"
            ? "rounded mx-2 bg-indigo-900 py-2 px-4 text-white"
            : "rounded mx-2 bg-indigo-700 hover:bg-indigo-800  py-2 px-4 text-white"
        }
        onClick={() => setActive("software-engineering")}
      >
        Software Engineering
      </button>

    </div>
  );
};

export default ThesisFilter;